module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.d8ba00bc.eot";